/* src/app/component/dialogs/confirm-dialog/confirm-dialog.scss */
/*# sourceMappingURL=confirm-dialog.css.map */
